import React, { useState, useEffect, createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const TrackingID = 'G-K1XD2N2SD3';
const TrackingContext = createContext();

function TrackingProvider({ children }) {
  const location = useLocation();
  const [analytics, setAnalytics] = useState({
    isInitialized: false,
  });

  // Handle route changes
  const handleRouteChange = (path, title) => {
    if (analytics.isInitialized) {
      ReactGA.send({
        hitType: 'pageview',
        page: path,
        title: title,
      });
    }
  };

  useEffect(() => {
    const { isInitialized } = analytics;

    if (!isInitialized) {
      try {
        ReactGA.initialize([
          {
            trackingId: TrackingID,
          },
        ]);

        setAnalytics((prev) => ({
          ...prev,
          isInitialized: true,
        }));
      } catch (error) {
        console.error('Failed to initialize Google Analytics:', error);
      }
    }
  }, []);

  // Track page views on route changes
  useEffect(() => {
    const windowTitle = document.title;
    //console.log('GA: route change', location.pathname, windowTitle);
    handleRouteChange(location.pathname, windowTitle);
  }, [location.pathname]);

  const trackEvent = (event, params) => {
    if (analytics.isInitialized) {
      try {
        ReactGA.event(event, params);
      } catch (error) {
        console.error('Failed to track event:', error);
      }
    } else {
      console.error('GA is not initialized');
    }
  };

  return (
    <TrackingContext.Provider
      value={{
        isInitialized: analytics.isInitialized,
        trackEvent,
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
}

const useTracking = () => {
  const context = useContext(TrackingContext);
  if (context === undefined) {
    throw new Error('useTracking must be used within a TrackingProvider');
  }
  return context;
};

export { TrackingProvider, useTracking };
